import { useEffect } from 'react';

/**
 * Hook to handle Escape key press to close modal
 * @param isOpen - Whether the modal is currently open
 * @param isDismissible - Whether the modal can be dismissed by clicking outside or pressing Escape
 * @param onClose - Callback function to close the modal
 */
export function useModalKeyboard(isOpen: boolean, isDismissible: boolean, onClose: () => void) {
  useEffect(() => {
    if (!isOpen || !isDismissible) return;

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, isDismissible, onClose]);
}
